const REDUCER = "@USER/";

const actions = {
  GET_LIST_USER: `${REDUCER}GET_LIST_USER`,
  SET_LIST_USER: `${REDUCER}SET_LIST_USER`,
  SET_IS_LOADING: `${REDUCER}SET_IS_LOADING`,
  SET_CURRENT_USER: `${REDUCER}SET_CURRENT_USER`,
};
export default actions;
